import { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";

const RedirectToSignUp = () => {
  const { loginWithRedirect } = useAuth0();
  const currentUrl = window.location.protocol + "//" + window.location.host;

  useEffect(() => {
    loginWithRedirect({
      screen_hint: 'signup',
      redirectUri: currentUrl + "/home",
    }).catch(error => {
      console.error('Login redirect failed', error);
    });
  });
};

export default RedirectToSignUp;